import { ChangeDetectionStrategy, Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { HelpStepper } from '../models/helpStepper.model';
import { MatStepper } from '@angular/material/stepper';

@Component({
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-help-index',
  templateUrl: './help-index.component.html',
  styles: []
})
export class HelpIndexComponent implements OnInit {
  @Input() model: HelpStepper;
  @ViewChild("stepper") stepper: MatStepper;
  @Output() helpFinish = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit() {
    // eslint-disable-next-line no-console
    console.log(this.model);
    // eslint-disable-next-line no-console
    console.log('title', this.model.title);
  }

  move (index: number) {
    this.stepper.selectedIndex = index + 1;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  action(item:any){
    item.execute();
  }

  reset() {
    this.stepper.reset();
  }

  close() {
    this.helpFinish.emit(true);
  }
  
}
